import React from 'react';
import { IconButton, Typography } from '@mui/material';
import {
  PlayArrowRounded,
  PauseRounded,
  Replay10Rounded,
  Forward10Rounded,
  LoopRounded,
} from '@mui/icons-material';
import { Tooltip } from 'src/shared/ui/tooltip';
import { usePlayerContext } from '../../context/player-context';

interface PlaybackControlsProps {
  isPlaying: boolean;
  togglePlayPause: () => void;
  handleRewind: () => void;
  handleForward: () => void;
  isMobile: boolean;
}

export const PlaybackControls: React.FC<PlaybackControlsProps> = ({
  isPlaying,
  togglePlayPause,
  handleRewind,
  handleForward,
  isMobile,
}) => {
  const { playbackSpeed, loopEnabled, handlePlaybackSpeedChange, clearLoop, openLoopModal } =
    usePlayerContext();

  return (
    <div className="flex items-center space-x-1 md:space-x-2">
      {/* Play/Pause button */}
      <Tooltip
        content={<Typography variant="button-s">{isPlaying ? 'Pausa' : 'Riproduci'}</Typography>}
        portal
      >
        <IconButton onClick={togglePlayPause} className="text-white hover:text-primary-light">
          {isPlaying ? <PauseRounded /> : <PlayArrowRounded />}
        </IconButton>
      </Tooltip>

      {/* Rewind button */}
      <Tooltip content={<Typography variant="button-s">Indietro 10s</Typography>} portal>
        <IconButton onClick={handleRewind} className="text-white hover:text-primary-light">
          <Replay10Rounded />
        </IconButton>
      </Tooltip>

      {/* Forward button */}
      <Tooltip content={<Typography variant="button-s">Avanti 10s</Typography>} portal>
        <IconButton onClick={handleForward} className="text-white hover:text-primary-light">
          <Forward10Rounded />
        </IconButton>
      </Tooltip>

      {/* Desktop-only additional controls */}
      {!isMobile && (
        <>
          {/* Playback speed */}
          <Tooltip
            content={<Typography variant="button-s">Velocità di Riproduzione</Typography>}
            portal
          >
            <IconButton
              onClick={handlePlaybackSpeedChange}
              className="hidden text-white hover:text-primary-light sm:block"
            >
              <Typography variant="button-m">{playbackSpeed}x</Typography>
            </IconButton>
          </Tooltip>

          {/* Loop control */}
          <Tooltip content={<Typography variant="button-s">Loop</Typography>} portal>
            <IconButton
              onClick={loopEnabled ? clearLoop : openLoopModal}
              className="hidden p-0 text-white hover:text-primary-light sm:flex"
            >
              <LoopRounded className="size-5 md:size-6" />
            </IconButton>
          </Tooltip>
        </>
      )}
    </div>
  );
};
